<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b-row class="align-items-center">
          <b-col>
            <h3 class="m-0">Gerenciamento de Procedimentos</h3>
          </b-col>
          <b-col class="text-right">
            <b-button variant="primary" @click="novoProcedimento">
              Novo
            </b-button>
          </b-col>
        </b-row>
      </b-card-header>

      <b-card-body>
        <b-table
          :items="procedimentos"
          :fields="fields"
          :busy="loading"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          no-local-sorting
          show-empty
          responsive
        >
          <template #empty>
            <div class="text-center">Nenhum registro encontrado.</div>
          </template>

          <template v-slot:cell(acao)="data">
            <b-dropdown
              variant="clean"
              size="small"
              toggle-class="btn-icon"
              no-caret
            >
              <template #button-content>
                <i class="fas fa-ellipsis-h"></i>
              </template>

              <b-dropdown-item @click="editarProcedimento(data.item)"
                >Editar</b-dropdown-item
              >
              <b-dropdown-item @click="excluir(data.item.id)" variant="danger"
                >Excluir</b-dropdown-item
              >
            </b-dropdown>
          </template>
        </b-table>
      </b-card-body>

      <b-card-footer>
        <div
          class="d-flex justify-content-between align-items-center flex-wrap"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="m-0"
          ></b-pagination>

          <div class="d-flex align-items-center flex-wrap">
            <b-select v-model="perPage" size="sm" class="mr-4 per-page">
              <option
                v-for="option in [20, 50, 100]"
                :key="option"
                :value="option"
              >
                {{ option }}
              </option>
            </b-select>

            <span>
              Exibindo de {{ fromPage }} até {{ toPage }} de
              {{ totalRows }} registros.
            </span>
          </div>
        </div>
      </b-card-footer>
    </b-card>

    <procedimento-formulario
      ref="mdlProcedimentoFormulario"
      @atualizar="getProcedimentos"
    ></procedimento-formulario>
  </div>
</template>

<script>
import ProcedimentoService from "@/core/services/procedimento.service";
import ProcedimentoFormulario from "./ProcedimentoFormulario.vue";
import moment from "@/core/plugins/moment";
import Swal from "sweetalert2";

export default {
  name: "procedimento-listar",

  components: {
    ProcedimentoFormulario,
  },

  data() {
    return {
      procedimentos: [],
      loading: false,
      fields: [
        {
          key: "codigo",
          label: "Código",
          class: "text-center align-middle",
          sortable: true,
        },
        {
          key: "nome",
          label: "Nome",
          class: "align-middle",
          sortable: true,
        },
        {
          key: "preco",
          label: "Preço",
          sortable: true,
          class: "text-right align-middle",
          formatter: "moedaFormatter",
        },
        {
          key: "idade_minima",
          label: "Idade Mínima",
          sortable: true,
          class: "text-right align-middle",
        },
        {
          key: "idade_maxima",
          label: "Idade Máxima",
          sortable: true,
          class: "text-right align-middle",
        },
        { key: "acao", label: "Ação", class: "text-center align-middle" },
      ],
      totalRows: 0,
      toPage: 0,
      fromPage: 0,
      currentPage: 1,
      perPage: 20,
      sortBy: "nome",
      sortDesc: false,
    };
  },

  mounted() {
    this.getProcedimentos();
  },

  methods: {
    getProcedimentos() {
      this.loading = true;

      ProcedimentoService.getProcedimentos({
        page: this.currentPage,
        perPage: this.perPage,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
      })
        .then(({ data }) => {
          this.procedimentos = data.data;
          this.totalRows = data.total;
          this.toPage = data.to;
          this.fromPage = data.from;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    novoProcedimento() {
      this.$refs.mdlProcedimentoFormulario.exibirModal();
    },

    editarProcedimento(procedimento) {
      this.$refs.mdlProcedimentoFormulario.exibirModal(procedimento);
    },

    async excluir(id) {
      Swal.fire({
        title: "Atenção!",
        text: "Deseja realmente excluir este procedimento?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then(async (result) => {
        if (result.value) {
          await ProcedimentoService.excluir(id).then(() => {
            Swal.fire(
              "Sucesso!",
              "Procedimento excluído com sucesso.",
              "success"
            );
            this.getProcedimentos();
          });
        }
      });
    },

    dataFormatter(value) {
      return value ? moment(value).format("DD/MM/YYYY") : "";
    },

    dataHoraFormatter(value) {
      return value ? moment(value).format("DD/MM/YYYY HH:mm:ss") : "";
    },

    moedaFormatter(value) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },

    showOverlay() {
      this.$store.dispatch("toggleOverlay", {
        value: true,
        message: "Processando, aguarde...",
      });
    },

    hideOverlay() {
      this.$store.dispatch("toggleOverlay", { value: false });
    },
  },

  watch: {
    currentPage() {
      this.getProcedimentos();
    },

    perPage() {
      this.getProcedimentos();
    },

    sortBy() {
      this.getProcedimentos();
    },

    sortDesc() {
      this.getProcedimentos();
    },
  },
};
</script>

<style scoped>
.per-page {
  height: calc(1.244em + 1.1rem + 2px) !important;
  width: 70px !important;
}
</style>
